export const ApiKeyCacheKey = ['apiKey', 'status'];
